import axios from 'axios';
import { getDomain } from '../../../helpers/getDomain';


// Create an instance of axios
const axiosInstance = axios.create({
  baseURL: getDomain(), // Replace with your API base URL
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Retrieve the token (e.g., from localStorage or a context)
    const token = localStorage.getItem("token")

    // If token exists, add it to the Authorization header
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;

      
    }

    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Optionally, add a response interceptor (e.g., for error handling)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle response errors
    console.error('API Error:', error.response || error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;